import React, { useEffect } from 'react';


const ExternalScriptBlock = ({ isSSR, scriptTags, htmlContainer, initFunction }) => {
  const injectScript = (script) => {
    const scriptElement = document.createElement("script");
    scriptElement.innerHTML = script;
    return document.body.appendChild(scriptElement);
  };

  useEffect(() => {
    if (!isSSR) {
      const idMatch = typeof htmlContainer === 'string' && htmlContainer?.match(/id="([^"]+)"/);
      const idValue = idMatch && idMatch?.[1];

      const el = document.getElementById(idValue);

      const parser = new DOMParser();
      const doc = parser.parseFromString(scriptTags, 'text/html');
      const scriptTag = doc.querySelector('script');
      const script = document.createElement('script');
      const styleElement = document.createElement('style');
      const styleTag = doc.querySelector('style');

      if (scriptTag) {
        if (scriptTag?.src) script.src = scriptTag.src;
        script.async = scriptTag?.async || true;
        script.defer = scriptTag?.defer || true;
      }

      if (styleTag) {
        styleElement.innerHTML = styleTag.innerHTML;
        document.head.appendChild(styleElement);
      }

      if (initFunction) {

        const initFunctionBody = initFunction.match(/\{([\s\S]*)\}/)[1];
        injectScript(initFunction)

        // eslint-disable-next-line no-new-func
        const init = new Function(initFunctionBody);
        script.onload = init;
      }

      if (el) {
        el.appendChild(script);
      } else {
        document.body.appendChild(script);
      }


      return () => {
        document.body.removeChild(script);
        document.body.removeChild(styleElement);
      };
    }
  }, [isSSR, scriptTags]);

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: htmlContainer }} />
    </div>
  )
}

export default ExternalScriptBlock;
